import { Event } from '@/app/event-stream';

export const SectionStatusChangedEventName = 'section-status-changed' as const;
export interface SectionStatusChangedEvent {
  sectionId: string;
  title: string;
  progress: Progress;
  previousProgress: Progress;
}

interface Progress {
  completion: number;
  scroll: number;
  page: number;
  status: SectionStatus;
}

export function calculateStatus(completion: number): SectionStatus {
  if (Math.floor(Math.round(completion)) === 100) {
    return 'completed';
  }

  return 'incomplete';
}

export type SectionStatus = 'not-attempted' | 'incomplete' | 'completed';

export function progressEquals(a: Progress, b: Progress) {
  return a.completion === b.completion &&
        a.page === b.page &&
        a.scroll === b.scroll;
}

export const sectionStatusEventNames = [
  SectionStatusChangedEventName
];

export type SectionStatusEvent =
      Event<typeof SectionStatusChangedEventName, SectionStatusChangedEvent>;
